var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99984 0.333334H37.9998C40.9454 0.333334 43.3332 2.72115 43.3332 5.66667V34.36C43.3313 36.481 42.4872 38.5145 40.9865 40.0133L29.6798 51.32C28.181 52.8207 26.1475 53.6648 24.0265 53.6667H5.99984C3.05432 53.6667 0.666504 51.2789 0.666504 48.3333V5.66667C0.666504 2.72115 3.05432 0.333334 5.99984 0.333334ZM37.9998 32.3333V5.66667H5.99984V48.3333H21.9998V35C21.9998 33.5272 23.1937 32.3333 24.6665 32.3333H37.9998ZM12.6665 16.3333H31.3332C32.0696 16.3333 32.6665 15.7364 32.6665 15V12.3333C32.6665 11.597 32.0696 11 31.3332 11H12.6665C11.9301 11 11.3332 11.597 11.3332 12.3333V15C11.3332 15.7364 11.9301 16.3333 12.6665 16.3333ZM23.3332 27H12.6665C11.9301 27 11.3332 26.403 11.3332 25.6667V23C11.3332 22.2636 11.9301 21.6667 12.6665 21.6667H23.3332C24.0696 21.6667 24.6665 22.2636 24.6665 23V25.6667C24.6665 26.403 24.0696 27 23.3332 27Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogFiles);
export default __webpack_public_path__ + "static/media/log-files.a688af2c4c1979b66b5418b779793681.svg";
export { ForwardRef as ReactComponent };